<script>
export default {
  translate25Context: 'vprojector',
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {
    orderedCategories: function () {
      return Object.values(this.component.categories).sort(function (a, b) {
        return parseInt(a.weight) - parseInt(b.weight);
      });
    },
  },
};
</script>

<template>
  <div class="container">
    <f-sexy-scroll>
      <div class="f-content">
        <div class="title">{{ $vt('Start a new project') }}</div>
        <div class="categories">
          <component
            v-for="(category, nid) in orderedCategories"
            :key="nid"
            v-bind:is="category.data.type"
            :component="category"
            :handler="handler"
          >
          </component>
        </div>
        <div class="f-button-justify">
          <f-button class="open" :type="['secondary']" href="#/open"
            >{{ $vt('Open Project') }} <f-icon icon="fa6-arrow-right"> </f-icon>
          </f-button>
          <f-button class="buy" :type="['tertiary']" href="#/extra_hours"
            >{{ $vt('Buy Extra hours') }}
          </f-button>
        </div>
      </div>
    </f-sexy-scroll>
  </div>
</template>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
  padding: 10px;

  .f-sexy-scroll {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .f-sexy-scroll-inner {
    }
  }

  .f-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > .title {
      font-family: Lato;
      font-weight: normal;
      font-size: 48px;
      line-height: 100%;
      color: var(--white-a75);
	  
	  .titleplus {
		color: var(--white-a90);
	  }
    }

    > .categories {
      margin-top: 48px;
      display: flex;
      gap: 32px;
      flex-wrap: wrap;
      justify-content: center;
    }

    .f-button-justify {
      display: flex;
      align-items: stretch;
      flex-direction: column;

      > .open {
        margin-top: 48px;
      }

      > .buy {
        margin-top: 12px;
      }
    }
  }
}
</style>